import React, { useState } from "react";
import classes from "./chat.module.css";
import { Avatar, Typography, Button, Box, Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import { LiaCheckDoubleSolid } from "react-icons/lia";
import moment from "moment";
import { generateColor, stringAvatar } from "../../../utilities/commonFunctions";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import BlockIcon from "@mui/icons-material/Block";
import { decodeFileName } from "../../../utilities/fileName";

const IMAGE_EXTS = ["jpg", "jpeg", "png", "gif", "webp", "heic", "heif", "svg", "bmp"];
const AUDIO_EXTS = ["mp3", "m4a", "wav", "ogg", "opus", "aac", "flac", "wma"];
const PDF_EXTS = ["pdf"];

const getFileType = (fileName) => {
  if (!fileName) return "file";
  const ext = fileName.split(".").pop()?.toLowerCase() || "";
  if (IMAGE_EXTS.includes(ext)) return "image";
  if (AUDIO_EXTS.includes(ext)) return "audio";
  if (PDF_EXTS.includes(ext)) return "pdf";
  return "file";
};

const MessageComponent = ({
  userInfo,
  message,
  index,
  openProfile,
  selectedUserProfile,
  selectedChat,
}) => {
  // const [currentTime, setCurrentTime] = useState(0);
  // const [audio, setAudio] = useState();
  // const [duration, setDuration] = useState(0);
  // const waveSurferRef = useRef({
  //   isPlaying: () => false,
  // });
  // const [isPlaying, toggleIsPlaying] = useState(false);
  // const isComponentMounted = useRef(true);

  // useEffect(() => {
  //   // Set the flag to true when the component is mounted
  //   isComponentMounted.current = true;

  //   // Cleanup function to set the flag to false when the component is unmounted
  //   return () => {
  //     isComponentMounted.current = false;
  //   };
  // }, []);

  // useEffect(() => {
  //   if (message.file_name.includes("mp3")) {
  //     setAudio(message.file_url);
  //   }
  // }, [message]);

  // useEffect(() => {
  //   const WavesurferId = `waveform${index}`;

  //   const initializeWaveSurfer = () => {
  //     const waveSurfer = WaveSurfer.create({
  //       container: `#${WavesurferId}`,
  //       hideScrollbar: true,
  //       waveColor: "#CDD5E5",
  //       progressColor: "blue",
  //       cursorColor: "black",
  //       barWidth: 3,
  //       barHeight: 10,
  //       minPxPerSec: 10,
  //       barGap: 2,
  //       height: 18,
  //     });

  //     waveSurfer.load(audio);

  //     waveSurfer.on("ready", () => {
  //       setDuration(waveSurfer.getDuration());
  //       waveSurferRef.current = waveSurfer;
  //     });

  //     waveSurfer.on("audioprocess", () => {
  //       setCurrentTime(waveSurfer.getCurrentTime());
  //     });

  //     return waveSurfer;
  //   };

  //   if (isComponentMounted.current) {
  //     const waveSurferInstance = initializeWaveSurfer();

  //     // Cleanup function to destroy the WaveSurfer instance when the component is unmounted
  //     return () => {
  //       waveSurferInstance.destroy();
  //     };
  //   }
  // }, [audio, index]);

  // const formatTime = (time) => {
  //   const minutes = Math.floor(time / 60);
  //   const seconds = Math.floor(time % 60);
  //   return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  // };
  const [previewOpen, setPreviewOpen] = useState(false);

  // Prefer the backend's own verdict (`is_mine`, decided server-side where the
  // authenticated caller is known for certain). Falls back to comparing ids
  // locally, so this still works against a backend not yet redeployed with
  // that field.
  const isMine =
    typeof message.is_mine === "boolean"
      ? message.is_mine
      : String(message.sender_id || "") === String(userInfo?._id || "");

  return (
    <Box
      key={index}
      className={
        isMine
          ? classes.sentMessageContainer
          : classes.receivedMessageContainer
      }
      sx={{ mb: 2 }}
    >
      <div className={classes.Messagecontainer}>
        {isMine ? (
          <div>
            {userInfo &&
            userInfo?.profile &&
            userInfo?.profile_pic?.filename ? (
              <Avatar
                alt="Remy Sharp"
                src={`${process.env.REACT_APP_IMAGE_URL}/${userInfo?.profile_pic?.destination}${userInfo?.profile_pic?.filename}`}
              />
            ) : (
              <Avatar
                {...stringAvatar(`${userInfo?.name?.trim()}`)}
                sx={{
                  backgroundImage:
                    "linear-gradient(to bottom, #1273B8, #BE5060)",
                }}
                style={{
                  width: "16px",
                  height: "16px",
                  fontSize: "8px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                }}
              />
            )}
          </div>
        ) : (
          <div>
            {message.senderInfo &&
            message.senderInfo?.profile_pic &&
            selectedUserProfile?.profile_pic?.filename ? (
              <Avatar
                alt="Remy Sharp"
                src={`${process.env.REACT_APP_IMAGE_URL}/${selectedUserProfile?.profile_pic?.destination}${selectedUserProfile?.profile_pic?.filename}`}
              />
            ) : (
              <Avatar
                {...stringAvatar(`${message.senderInfo?.name?.trim()}`)}
                sx={{
                  bgcolor: selectedChat?.departmentInfo?.colour
                    ? selectedChat?.departmentInfo?.colour
                    : `${generateColor(
                        `${selectedChat?.receiverDetails[0]?.name}`
                      )}`,
                }}
                style={{
                  width: "16px",
                  height: "16px",
                  fontSize: "8px",
                  fontWeight: 600,
                  textTransform: "uppercase",
                }}
              />
            )}
          </div>
        )}
        {message.is_deleted ? (
          <div
            className={classes.Message}
            style={{
              maxWidth: openProfile ? "400px" : "500px",
              display: "flex",
              alignItems: "center",
              gap: 6,
              fontStyle: "italic",
              opacity: 0.7,
            }}
          >
            <BlockIcon style={{ fontSize: 16 }} />
            <Typography style={{ fontStyle: "italic" }}>
              This message was deleted
            </Typography>
          </div>
        ) : message.message ? (
          <div
            className={classes.Message}
            style={{ maxWidth: openProfile ? "400px" : "500px" }}
          >
            <Typography style={{ wordBreak: "break-word" }}>
              {message.message}
              {message.is_edited && (
                <span style={{ fontSize: 11, opacity: 0.7, marginLeft: 6 }}>
                  (edited)
                </span>
              )}
            </Typography>
            {isMine && message.status === "seen" ? (
              <LiaCheckDoubleSolid className={classes.seenIcon} />
            ) : isMine && message.status === "unseen" ? (
              <LiaCheckDoubleSolid className={classes.unseenIcon} />
            ) : null}
          </div>
        ) : (
          <div
            className={classes.Message}
            style={{ maxWidth: openProfile ? "400px" : "500px", padding: 5 }}
          >
            {getFileType(message?.file_name) === "audio" ? (
              <div>
                <audio controls>
                  <source src={message?.file_url} type="audio/ogg" />
                  <source src={message?.file_url} type="audio/mpeg" />
                </audio>
              </div>
            ) : getFileType(message?.file_name) === "image" ? (
              <>
                <img
                  src={message?.file_url}
                  alt=""
                  className={classes.FileImage}
                  onClick={() => setPreviewOpen(true)}
                  style={{ cursor: "pointer" }}
                />
                <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md" fullWidth>
                  <DialogTitle style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    {decodeFileName(message?.file_name) || "Image Preview"}
                    <IconButton onClick={() => setPreviewOpen(false)} size="small">
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent dividers style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: 300 }}>
                    <img
                      src={message?.file_url}
                      alt={decodeFileName(message?.file_name) || ""}
                      style={{ maxWidth: "100%", maxHeight: 500 }}
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button variant="contained" startIcon={<DownloadIcon />} onClick={() => window.open(message?.file_url, "_blank", "noopener,noreferrer")}>
                      Download
                    </Button>
                  </DialogActions>
                </Dialog>
              </>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "4px 8px", cursor: "pointer" }} onClick={() => window.open(message?.file_url, "_blank", "noopener,noreferrer")}>
                {getFileType(message?.file_name) === "pdf" ? (
                  <PictureAsPdfIcon style={{ color: "#e53935", fontSize: 32, flexShrink: 0 }} />
                ) : (
                  <InsertDriveFileIcon style={{ color: "#1273B8", fontSize: 32, flexShrink: 0 }} />
                )}
                <div>
                  <Typography style={{ fontSize: 13, fontWeight: 500, wordBreak: "break-all", maxWidth: 200 }}>
                    {decodeFileName(message?.file_name) || "File"}
                  </Typography>
                  <Typography style={{ fontSize: 11, color: "#888" }}>
                    Tap to open
                  </Typography>
                </div>
                <DownloadIcon style={{ color: "#555", fontSize: 18, marginLeft: "auto" }} />
              </div>
            )}
          </div>
        )}
        <Typography className={classes.Chat_lastMessage}>
          {moment(message?.time).format("hh:mm A")}
        </Typography>
      </div>
    </Box>
  );
};

export default MessageComponent;
